import React from "react";
import {
	getCartstore,
	getCountries,
	GetCountriesResp,
	getCurrencies,
	getLanguages,
	getUserProfile,
	CountryInfo,
	CurrencyInfo,
	LanguageInfo,
	getInfo,
} from "../../../headerServices/header/header";
import HeaderNav from "./components/Nav";
import HeaderPageLet from "./components/PageLet";
import Constant from "../../../utils/constant";
import { Header, HeaderContainer } from "./styles";
import { headerConstant } from "./webHeaderConstant";


export interface CartStore {
	totalLen: number;
	totalPrice: string;
	items: any[];
	currencySymbol: string;
}


export interface OnSentryCatchParam {
	request: string;
	error: string;
}

interface WebHeaderProps {
    isDev?: boolean;
	isUat?: boolean;
	cookies?: { [key: string]: string };
	runtime?: {
		languageCode: string;
		countryCode: string;
		currency: string;
		sid: string;
		platform: string;
		countryCode2?: string;
		countryId?: string;
	};
	onChangeLanguage?: (lan?: string) => void;
	onSentryCatch?: (props: OnSentryCatchParam) => void;
}

interface WebHeaderState {
	/** 用户名 */
	userName: string;
	/** 购物车 */
	cart: CartStore;
	/** except top, 全部国家/地区 */
	countries: CountryInfo[];
	topCountries: CountryInfo[];
	/** 用户当前国家/地区 */
	userCountry: CountryInfo;
	/** 全部货币 */
	currencies: CurrencyInfo[];
	/** 用户当前货币 */
	userCurrency: CurrencyInfo;
	/** 全部语言 */
	languages: LanguageInfo[];
	/** 用户当前语言 */
	userLanguage: Partial<LanguageInfo>;
	/** 低价APP 折扣应用国家国际化文案 */
	lowPriceCountryPriceOff: string;
}

class WebHeader extends React.Component<WebHeaderProps, WebHeaderState>{

    state: WebHeaderState = {
		userName: "",
		cart: {
			totalLen: 0,
			totalPrice: "",
			items: [],
			currencySymbol: ""
		},
		countries: [],
		topCountries: [],
		userCountry: null,
		currencies: [],
		userCurrency: null,
		languages: [],
		userLanguage: {},
		lowPriceCountryPriceOff: ""
	};

    componentDidMount() {
		if (Constant.isLogin) {
			this.getUser();
		}
		this.getAppLowpriceCountry();
		this.getCart();
		this.getCountry();
		this.getCurrency();
		this.getLanguage();
	}

	/** 获取用户信息 */
	getUser = () => {
		getUserProfile({
			sessionkey: Constant.sessionKey ? Constant.sessionKey : undefined
		}, { onSentryCatch: this.props.onSentryCatch })
			.then((res: any) => {
				const { user = 0 } = res.info || {};
				const userName = user.email ? user.email.split("@")[0] : user.user_id;
				this.setState({ userName });
			})
			.catch(err => {
				console.log(err);
			});
	};

	/** 获取购物车数量 */
	getCart = () => {
		getCartstore({
			sessionkey: Constant.sessionKey ? Constant.sessionKey : undefined
		}, { onSentryCatch: this.props.onSentryCatch })
			.then((res: any) => {
				const { total_results = 0, cart_items = [], codTipsRef, cart_totals = [] } =
					res.info || [];
				const cart: CartStore = {
					totalLen: total_results,
					totalPrice: cart_totals?.[1]?.price || "0",
					currencySymbol: codTipsRef?.currencySymbol || "",
					items: cart_items
				};
				this.setState({ cart });
			})
			.catch(err => {
				console.log(err);
			});
	};

	/** 获取 Country */
	getCountry = () => {
		getCountries(null, { onSentryCatch: this.props.onSentryCatch })
			.then((res: GetCountriesResp) => {
				const { countries = [], topCountries } = res.info || {};
				const userCountry =
					countries.find(item => item?.countryIsoCode3 === Constant.country);
				this.setState({
					countries,
					topCountries,
					userCountry
				});
			})
			.catch(err => {
				console.log(err);
			});
	};

	/** 获取 Language */
	getLanguage = () => {
		getLanguages(null, { onSentryCatch: this.props.onSentryCatch })
			.then((res: any) => {
				const { languages = [] } = res.info || [];
				const userLanguage =
					languages.find(item => item?.language_code === Constant.language) || {};
				this.setState({
					userLanguage,
					languages
				});
			})
			.catch(err => {
				console.log(err);
			});
	};

	/** 获取 Currency */
	getCurrency = () => {
		getCurrencies(null, { onSentryCatch: this.props.onSentryCatch })
			.then((res: any) => {
				const { currencies = [], new_currencies = [] } = res.info || {};
				let currencyList = [];
				if (new_currencies && new_currencies.length > 0) {
					currencyList = new_currencies;
				} else {
					currencyList = currencies;
				}
				const userCurrency =
					currencyList.find(item => item?.currency_code === Constant.currency) || {};
				this.setState({
					userCurrency,
					currencies: currencyList
				});
			})
			.catch(err => {
				console.log(err);
			});
	};

	// 底价APP规则应用国家列表
	getAppLowpriceCountry = () => {
		const ATTRNAME_KEY = "APP_LOWPRICE_COUNTRY";
		getInfo({ namespace: "LITB.OTHER.COUNTRIES", attrName: ATTRNAME_KEY },
			{ onSentryCatch: this.props.onSentryCatch })
			.then((res: any) => {
				const { value = {} } = res.info || {};
				const keyValue: string = value[ATTRNAME_KEY] || "";
				if ((keyValue as string).split(",").includes(Constant.countryId)) {
					this.getAppLowPriceTextContent();
				}
			})
			.catch(err => {
				console.warn(err);
			});
	};

	// 获取导流国际化文案
	getAppLowPriceTextContent = () => {
		const ATTRNAME_KEY = "DEFAULT.TXT_MOBILE_ENTRANCE_NEW";
		getInfo({ namespace: "LITB.LANG.VELA", attrName: ATTRNAME_KEY, nsLanguageCode: Constant.language },
			{ onSentryCatch: this.props.onSentryCatch })
			.then((res: any) => {
				const { value = {} } = res.info || {};
				this.setState({ lowPriceCountryPriceOff: value[ATTRNAME_KEY] || "" });
			})
			.catch(err => {
				console.warn(err);
			});
	}

    render() {
        const {
			userName,
			cart,
			countries = [],
			topCountries = [],
			userCountry,
			currencies,
			userCurrency,
			languages = [],
			userLanguage,
			lowPriceCountryPriceOff
		} = this.state;

        return(
            <Header>
                <HeaderContainer>
                    <HeaderNav
						countries={countries}
						popularCounties={topCountries}
						userCountry={userCountry}
						currencies={currencies}
						userCurrency={userCurrency}
						languages={languages}
						userLanguage={userLanguage}
						onChangeLanguage={this.props.onChangeLanguage}
						lowPriceCountryPriceOff={lowPriceCountryPriceOff}
					/>
                    <HeaderPageLet cart={cart} userName={userName} />
                </HeaderContainer>
            </Header>
        )
    }
}

export default headerConstant(WebHeader);